import React, { Fragment } from 'react'; 
import Header from "../common/header";
import Footer from "../common/footer";
import MilestoneBanner from "./milestone-banner"; 
import MilestoneDescription from './milestone-description';
import MilestoneSwiper from './milestone-swiper';

function MilestonePage() {
  
    return (
      <Fragment> 
      <Header />  
      <MilestoneBanner />   
      <MilestoneDescription />
      <MilestoneSwiper />
      <Footer /> 

</Fragment> 
  );
}

export default MilestonePage;